import { Link } from '../../../types';
import { PATH_DASHBOARD } from '../../../app';

export const LINKS: Link[] = [
  { name: 'Dashboard', href: PATH_DASHBOARD.root },
  { name: 'Spare parts', href: PATH_DASHBOARD.spareParts.list },
  { name: 'New' },
];
